export const TimelineMarkerType = {
  Today: 'Today' as const,
  Custom: 'Custom' as const,
  Cursor: 'Cursor' as const,
};
